import ApiService from '@/services/core/api.service'

const RawDataService = {
  async get (query) {
    return ApiService.get(`supervisor/raw-data?${query}`)
  },

  async post (payload) {
    return ApiService.post('supervisor/raw-data', payload)
  },

  async put (payload) {
    return ApiService.put(`supervisor/raw-data/${payload.agent}`, payload)
  }
}

export default RawDataService
